import React from 'react'
import PropTypes from 'prop-types'
import classes from './map.module.scss'
import Iframe from 'react-iframe'

const BasinMap = (props) => {
    return 	<Iframe 
    			url="https://map-of-rivers-of-dnipro.firebaseapp.com"
		        id="map"
		        className={classes.map}
			/>
}

BasinMap.propTypes = {
    //products: PropTypes.array
}

export default BasinMap;
